import { ApiResponse, apiCall } from "./apiClient";
import { NotificationListItemDto } from "../models/notification/notification";
import { NotificationQueryParameters } from "../models/notification/notificationQueryParameters";
import { NotificationSource } from "../models/notification/notificationSource";

export const getDesktopNotifications = async(): Promise<
    NotificationListItemDto[]
> => {
    const response = await apiCall<NotificationListItemDto[]>(
        "Notifications",
        "GET",
        {
            source: [NotificationSource.DesktopToMobile, NotificationSource.SystemToDesktop],
            onlyUnconfirmed: true,
        }
    );
    return response.data;
};

export const confirmNotification = async(
    notificationId: string,
    qParams?: NotificationQueryParameters
): Promise<ApiResponse<unknown>> => {
    let url = `Notifications/${notificationId}/confirm`;
    if (qParams?.targetObjectType && qParams?.targetObjectId) {
        const params = new URLSearchParams();
        params.append("targetObjectType", qParams.targetObjectType);
        params.append("targetObjectId", qParams.targetObjectId);
        url += `?${params.toString()}`;
    }

    return apiCall<unknown>(url, "PUT");
};
